<template>
    <card-seplag :titulo="tituloTermo" cor="#00acc1" > 
        <div class="termo" v-if="termodeaceite">
            <div class="p-shadow-1" v-html="termodeaceite" />
        </div>
        <div class="p-col-12" v-if="flagAceito=='N'">    
            <div class="p-grid p-fluid">
                <div class="p-col-12 p-md-3">
                    <Button label="Não Concordo" icon="pi pi-times" @click="naoAceito" class="p-button p-button-danger" />
                </div>
                <div class="p-col-12 p-md-3">
                    <Button label="Concordo" icon="pi pi-check" @click="aceito()" class="p-button p-button-primary" />
                </div>
            </div>            
        </div>
        <Dialog header="Atenção!!" :visible.sync="dialogNaoConcordo" :style="{width: '75vw'}" :modal="true">
            <div class="confirmation-content text-center">
                <div v-html="textoDialogo" />
            </div>
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="fecharDialogo" class="p-button-text p-button-danger" />
                <Button label="Aceitar" icon="pi pi-times" @click="aceito(true)" class="p-button-text p-button-success" autofocus v-if="aceitouDialogo" />
            </template>
        </Dialog>
    </card-seplag>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl } from '@/config/global'
export default {
    name: "TermodeAceiteGPDP",
    components: {CardSeplag},
    data: function(){
        return {
            termodeaceite: null,
            tituloTermo: "Termo de Aceite Lei Geral de Proteção de Dados Pessoais",
            flagAceito: 'N',
            aceitouDialogo: false,
            dialogNaoConcordo: false,
            textoDialogo:"<p style='text-align: justify;'>Você não poderá começar o recadastramento sem concordar com o termo listado!</p>"

        }
    },
    mounted() {
        this.carregarDados();
    },      
    methods: {
        carregarDados(){
            if(this.$store.getters.getDadosPessoa){
                this.tituloTermo = this.$store.getters.getDadosPessoa.termo.descTermo
                this.termodeaceite =  this.$store.getters.getDadosPessoa.termo.infoTermo
                this.flagAceito = this.$store.getters.getDadosPessoa.flagTermoAceite
            }else{
                this.$router.push({name:"recadastramento"})
            }
        },
        aceito(aceitou = false){
            if(!aceitou){
                this.textoDialogo = "<p style='text-align: justify;'>Declaro ter ciência que as informações e os documentos inserido são inteiramente de minha responsalidade e que a inclusão de falsos na atualização cadastral será apurada mediante procedimento disciplinar, mantida a possibilidade de aplicação das demais penalidades prevista em lei.</p><p style='text-align: justify;'> Declaro ainda ter ciência que os dados coletados ficarão sob a gestão da Secretaria de Estado de Planejamento e Gestão/SEPLAG e somente serão ultilizados para fins estatisticos, ficando vetado a entidade fornecê-los à terveiros</p>"
                this.dialogNaoConcordo = true
                this.aceitouDialogo = true
            }else{
                this.$http.put(`${baseApiUrl}/ciclopessoas/termoaceite/${this.$store.getters.getCicloPessoa[0].id}`).then(dadosPessoa=>{
                    this.$store.commit("setDadosPessoa",JSON.stringify(dadosPessoa.data))                
                    this.$router.push({name: "RECAD_DADOS_PESSOAIS_VIEW"})
                })
            }
        },
        naoAceito(){            
            this.textoDialogo = "<p style='text-align: justify;'>Você não poderá começar o recadastramento sem concordar com o termo listado!</p>"
            this.dialogNaoConcordo = true
            this.aceitouDialogo = false
        },        
        fecharDialogo() {
            this.dialogNaoConcordo = false;
        }
    },    
    computed:{
        getDadosPessoa(){
            return this.$store.getters.getDadosPessoa
        }
    },
    watch:{
        getDadosPessoa(novoDadosPessoa){
            this.tituloTermo = novoDadosPessoa.termo.descTermo
            this.termodeaceite =  novoDadosPessoa.termo.infoTermo
            this.flagAceito = novoDadosPessoa.flagTermoAceite
            
        }
    }

}
</script>

<style>
.termo{
    width: 100%;
    height: 46em;
    overflow: auto;
    padding: 2px;
}
 @media screen and (max-width: 40em) {
    .termo{        
        height: 27em;
    }
 }
</style>